import moment from 'moment';
import forEach from 'lodash/forEach';
import { I18N } from '../../constants';

export const validateFields = ({
    trailerIdentifier,
    selectedDate,
    selectedStop,
    selectedReason,
    selectedManifests,
    tempManifests,
    isSlide,
    selectedRun,
    tapDate,
    tapDueDate,
    dueDate,
    comment,
}) => {
    const errors = {};

    if (trailerIdentifier && trailerIdentifier.length > 1000) {
        errors.trailerIdentifier = 'Trailer number cannot contain more than 1000 characters. ';
    }
    if (selectedDate && !moment(selectedDate).isValid()) {
        errors.date = 'Please insert a valid date with format: DD-MM-YYYY HH:mm';
    } else if (selectedDate && selectedDate.isAfter(moment())) {
        errors.date = 'A blow out can not be registered in the future.';
    }
    if (selectedStop === I18N.FORMS.SELECT_STOP) {
        errors.stop = 'You must select a location.';
    }
    if (selectedReason === I18N.FORMS.SELECT_REASON) {
        errors.reason = 'You must select a reason.';
    }
    if (selectedManifests && selectedManifests.length === 0) {
        errors.manifests = 'You must select at least one manifest.';
    }
    if (selectedRun === 'Route code - run date - run sequence') {
        errors.runs = 'You must select at least one run.';
    }
    if (tapDate === '') {
        errors.tapDate = 'You must choose a tap date.';
    }
    if (tapDueDate === '') {
        errors.tapDueDate = 'You must choose a tap due date.';
    }
    if (dueDate === '') {
        errors.dueDate = 'You must choose a due date for the recovery action.';
    }

    if (comment && comment.length > 1000) {
        errors.comment = 'Comments cannot contain more than 1000 characters.';
    }

    let noPallets = false;
    let moreThan10Pallets = false;
    forEach(tempManifests, m => {
        if (
            m.palletAmount <= 0 ||
            m.palletAmount === '' ||
            m.palletAmount === undefined ||
            m.palletAmount === null
        ) {
            noPallets = true;
        }
        if (m.palletAmount > 10) {
            moreThan10Pallets = true;
        }
    });

    if (noPallets && !isSlide) {
        errors.pallets = 'You must specify the number of pallets for all selected manifests.';
    }
    if (moreThan10Pallets && isSlide) {
        errors.moreThan10Pallets =
            'Attention! You have selected a manifest with more than 10 impacted pallets. If you want to slide the manifest, make sure this is correct.';
    }

    return errors;
};
